import { useMutation } from "@tanstack/react-query"
import processFilesService from "services/processFiles.service"
import { useMessagesDataStore } from "store/nats.store"
import { useFillesTableStore } from "store/table.store"
import { useMessage } from "hooks/message.hook"
import type { TProcessing } from "types/drawer.type"

export const useProcessFiles = () => {
	const { setProcessingIds, updateProcessingIds, processingIds } = useFillesTableStore()
	const { setMessagesData } = useMessagesDataStore()
	const { error: errorMessage } = useMessage()

	return useMutation({
		mutationKey: ["processingFiles"],
		mutationFn: ({ id, version }: TProcessing) => {
			if (id) setProcessingIds(id) // Set the ID of the file being processed
			return processFilesService.processFile({ id, version })
		},
		onSuccess: (_data, variables) => {
			// On success, remove the processed ID from processingIds
			const processedId = variables.id
			const updatedIds = processingIds.filter((id) => id !== processedId)
			updateProcessingIds(updatedIds)

			// Update the status of the processed ID to "in_queue" and set progress to 0
			if (processedId) {
				setMessagesData(processedId, {
					status: { status: "in_queue" },
					progress: 0,
				})
			}
		},
		onError: (_error, variables) => {
			// On error, also remove the ID from processingIds
			const processedId = variables.id
			const updatedIds = processingIds.filter((id) => id !== processedId)
			updateProcessingIds(updatedIds)

			errorMessage("Something went wrong, please try again later") // Show error message

			// Update the status of the processed ID to "failed"
			if (processedId) {
				setMessagesData(processedId, {
					status: { status: "failed" },
				})
			}
		},
	})
}
